export default function EmptyMessageBuilder()
{
    this.messages = {};
}

EmptyMessageBuilder.prototype = {
    createMessages: function()
    {
    },

    processEmptyMessages: function()
    {
        this.createMessages();
        return this.messages;
    }
};



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/emptyMessagesBuilders/EmptyMessageBuilder.js